// Config

export const env = process.env.NODE_ENV || 'development' // eslint-disable-line

/**
 * Api base
 * @type string
 */
// TODO remove encodeURIComponent in apiFetch when cors is gone
export const apiBase = '/api'

/**
 * Faculty Faces API base
 * @type string
 */
export const facultyFacesAPIBase = 'http://facultyfaces.core.uconn.edu/api'
export const facultyFacesAPIToken = 'hh1ZQqu6tfuAK4pgDjyUKJGGoSrgHgifJKDJANLhqirTfERsF7fAKuWs7ubm6fUhPx7JrW'

/**
 * Husky Tales API base
 * @type string
 */
export const huskyTalesAPIBase = 'https://huskytales.core.uconn.edu/api'

/**
* This site's title
* @type string
*/
export const siteTitle = 'UConn Innovation Portal'

/**
* This site's title, but shorter
* @type string
*/
export const siteTitleShorter = 'Innovation Portal'

/**
* Tagline for landing page
* @type {String}
*/
export const indexBody = 'Under the umbrella of UConn’s Office of the Vice President for Research, Technology Commercialization Services works with innovators, entrepreneurs, investors, and industry partners to transform UConn discoveries into products, companies, and jobs that benefit society and fuel economic development.'

/**
* Default meta description when none is available on the backend
* @type string
*/
export const defaultMetaDescription = 'Driving Discovery. Unleasing Technology. Growing Business. The Innovation Portal puts all of UConn\'s resources, technology and expertise at your fingertips.'

/**
* Tagline for faculty expertise search landing page
* @type string
*/
export const expertiseTagline = 'Find out what faculty at UConn are researching'

/**
* Twitter user url
* @type {String}
*/
export const twitterUrl = 'https://twitter.com/UConnResearch'

/**
* Linkedin Company url
* @type {String}
*/
export const linkedinUrl = 'https://www.linkedin.com/company/36020813'

/**
* Menu
* @type array
*/
export const menu = [
  {
    name: 'Technologies',
    slug: 'technologies',
    hint: 'Inventory of Innovations',
    items: [
      { name: 'Learn More', url: '/technologies' }
    ]
  },
  {
    name: 'Expertise',
    slug: 'expertise',
    hint: 'Find Faculty Experts',
    items: [
      { name: 'Learn More', url: '/expertise' }
    ]
  },
  {
    name: 'Partner',
    slug: 'resources',
    hint: 'Research/tech Transfer Processes',
    items: [
      { name: 'Learn More', url: '/resources' }
    ]
  },
  {
    name: 'Startups',
    slug: 'startups',
    items: [
      { name: 'Learn More', url: '/startups' }
    ]
  },
  {
    name: 'News',
    slug: 'news',
    hint: '',
    noMain: true,
    items: []
  },
  {
    name: 'News',
    slug: 'stories',
    landingOnly: true,
    items: []
  },
  {
    name: 'Twitter',
    slug: 'twitter',
    noLanding: true,
    items: []
  },
  {
    name: 'About',
    slug: 'about',
    hint: '',
    url: '/about',
    items: []
  },
  {
    name: 'Not Found',
    slug: 'not-found',
    hint: '',
    hidden: true,
    noMain: true,
    items: []
  }
]

/**
* Menu for social icons
* @type {Array}
*/
export const socialMenu = [
  { icon: 'fa-facebook-square', link: 'http://facebook.com' },
  { icon: 'fa-twitter-square', link: 'http://twitter.com' },
  { icon: 'fa-youtube-square', link: 'http://youtube.com' }
]

/**
 *
 */
export const researchUnleashedBlurbs = [
  { body: 'Over <strong>100</strong> world-class research centers and institutions', color: 'rgba(120,60,48, 0.5)' },
  { body: '<strong>$260</strong> million research expenditures in FY2015', color: 'rgba(225,171,17, 0.6)' },
  { body: 'Over <strong>1500</strong> full-time faculty conducting cutting-edge research', color: 'rgba(120,120,120, 0.8)' },
  { body: '<strong>$1.5 billion</strong> Next Generation Connecticut state investment through 2024 on main campus in Storrs', color: 'rgba(213,102,0, 0.6)' },
  { body: '<strong>880,000+</strong> square feet of research space', color: 'rgba(80,44,43, 0.8)' },
  { body: '<strong>500</strong> U.S. Patents granted based on UConn technologies', color: 'rgba(60,74,86, 0.8)' },
  { body: 'top <strong>25</strong> public research university', color: 'rgba(84,101,112, 0.5)' },
  { body: '<strong>75</strong> startups supported by Technology Incubation Program', color: 'rgba(71,90,0, 0.5)' },
  { body: '<strong>$864 million</strong> Bioscience Connecticut state investment in UConn Health research, academic, and clinical facilities', color: 'rgba(213,69,0, 0.6)' }
]

/**
* List of possible project types (slugs)
* @type array
*/
export const projectTypes = [
  'ip',
  'companies'
]

/**
* Map of project type slugs to titles
* @type object
*/
export const projectTypeTitles = {
  'ip': 'IP',
  'companies': 'Companies'
}

/**
* Map of project type slugs to bootstrap brands
* @type object
*/
export const projectTypeBrands = {
  'ip': 'success',
  'companies': 'info'
}

/**
* Bootstrap breakpoints (in pixels)
* @type object
*/
export const breakpoints = {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1200
}

/**
 * Bootstrap brand colors
 * @type object
 */
export const brandColors = {
  primary: '#2c3e50',
  success: '#048767',
  info: '#297ac3',
  warning: '#f39c12',
  danger: '#e74c3c'
}

/**
* Standard date format (see Moment.js docs)
*/
export const standardDateFormat = 'MMM D YYYY' // ex. Feb 14 2016

export const projectSortOptions = [
  [ 'relevance-asc', 'Most Relevant First' ],
  [ 'alpha-asc', 'Alphabetical (A to Z)' ],
  [ 'alpha-desc', 'Alphabetical (Z to A)' ],
  [ 'date-desc', 'Date (newest first)' ],
  [ 'date-asc', 'Date (oldest first)' ]
]

/**
 * Component configuration
 */

export const informationalMessage = 'Note: Search terms are based on keywords from publication titles in scholarly journals. This means that terms like “virus” are likely to yield better results than “virology." Didn\'t find what you’re looking for? We can help! Contact a member of the tech transfer team to get personalized help finding a faculty expert to help with your project.'

export const keywordCloudRenderLimit = 50

export const sitewideSearchSuggestions = [
  'general relativity',
  'topology',
  'homeostasis',
  'polymers',
  'geometric singularity detection',
  'wireless communication systems',
  'Health eSense',
  'Shoreline Biome, LLC',
  'azitra',
  'technology incubation program',
  'grant funding',
  'innovation partnership building',
  'cells',
  'protein',
  'genes',
  'HIV'
]

/**
 * About Page
 */
export const defaultContactGroup = 'OVPR Technology Commercialization Team'

/**
 * News and Events
 */
export const eventExpirationTimeDays = 1

/**
 * Map from routes to projectFilterType
 */

export const routesToTypes = { '/startups': 'companies', '/technologies': 'ip' }

/**
 * Map from slug to corresponding links
 */

export const slugsToLinks = { 'ip': '/technologies', 'companies': '/startups' }

/**
 * Map from slug to corresponding name for labels at /search
 */

export const slugsToLabels = { 'ip': 'technologies', 'companies': 'startups' }



// WEBPACK FOOTER //
// ./resources/assets/js/config.js